import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'jsonformat',
})
export class JsonFormatPipe implements PipeTransform {
    transform(value: any, spaces = 2): any {
        if (typeof value === 'string') {
            return JSON.stringify(JSON.parse(value), null, spaces);
        } else {
            return JSON.stringify(value, null, spaces);
        }
    }
}
